<template>
  <BaseModal ref="modal" modal-classes="max-w-5xl mx-auto" @modal-after-leave="$emit('closed')">
    <template #header>
      <span class="text-xs text-gray-700 uppercase tracking-wider">statistics</span>
      <h3 class="text-xl">
        {{ page.title }}
      </h3>
    </template>

    <template>
      <PageStats :page-id="page.id" />
    </template>
  </BaseModal>
</template>

<script>
import PageStats from './modalStats/PageStats.vue';

export default {
  name: 'ModalStats',
  components: {
    PageStats,
  },
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
